(() => {
  if (window.__loubnaArabicSearchV10) return;
  window.__loubnaArabicSearchV10 = true;

  const AR = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
  const DIA = /[\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06ED]/g;
  let catalogPromise;

  const norm = (v) => String(v || '').normalize('NFKC')
    .replace(/[٠-٩]/g, d => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
    .replace(/[۰-۹]/g, d => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(DIA, '').replace(/ـ/g, '')
    .replace(/[أإآٱ]/g, 'ا').replace(/[ىئ]/g, 'ي').replace(/ؤ/g, 'و').replace(/ة/g, 'ه')
    .replace(/[کڪ]/g, 'ك').replace(/[یۍېےۓ]/g, 'ي').replace(/[ۀہھ]/g, 'ه')
    .replace(/[^\p{L}\p{N}\s]+/gu, ' ').replace(/\s+/g, ' ').trim().toLowerCase();

  const simpleArabic = q => AR.test(String(q || '')) && !/[()"':]/.test(q) && !/\b(?:AND|OR|NOT)\b/i.test(q);
  const tokens = v => norm(v).split(/\s+/).filter(Boolean);
  const lev = (a, b, max) => {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    let p = Array.from({length: b.length + 1}, (_, i) => i), c = [];
    for (let i = 1; i <= a.length; i++) {
      c = [i]; let min = i;
      for (let j = 1; j <= b.length; j++) {
        c[j] = Math.min(c[j-1] + 1, p[j] + 1, p[j-1] + (a[i-1] === b[j-1] ? 0 : 1));
        min = Math.min(min, c[j]);
      }
      if (min > max) return max + 1;
      p = c;
    }
    return p[b.length];
  };
  const oneSubstitution = (a, b) => {
    if (a.length !== b.length) return false;
    let diff = 0;
    for (let i = 0; i < a.length; i += 1) {
      if (a[i] !== b[i] && ++diff > 1) return false;
    }
    return diff === 1;
  };
  const tokenMatch = (q, p) => {
    if (p === q || p.startsWith(q)) return true;
    if (q.length === 3 && p.length === 3 && oneSubstitution(q, p)) return true;
    if (q.length >= 4 && p.includes(q)) return true;
    if (q.length < 4) return false;
    const max = q.length >= 7 ? 2 : 1;
    return Math.abs(q.length - p.length) <= max && lev(q, p, max) <= max;
  };
  const text = p => norm([p.title, p.product_handle, p.handle, ...(p.tags || []), p.product_type, p.vendor].filter(Boolean).join(' '));
  const matches = (q, p) => {
    const n = norm(q), h = text(p);
    if (!n || !h) return false;
    if (h.includes(n)) return true;
    const pt = tokens(h);
    return tokens(n).every(t => pt.some(x => tokenMatch(t, x)));
  };
  const score = (q, p) => {
    const n = norm(q), t = norm(p.title), h = text(p);
    if (t === n) return 0;
    if (t.startsWith(n)) return 1;
    if (t.includes(n)) return 2;
    if (h.includes(n)) return 3;
    return 4;
  };

  const prefix = () => {
    const s = location.pathname.split('/').filter(Boolean)[0] || '';
    return /^[a-z]{2}(?:-[a-z]{2})?$/i.test(s) ? `/${s}` : '';
  };
  const indexUrl = page => {
    const u = new URL(`${prefix()}/collections/all`, location.origin);
    u.searchParams.set('view', 'ar-search-index');
    if (page > 1) u.searchParams.set('page', page);
    const src = new URLSearchParams(location.search);
    for (const [k, v] of src) if (k === 'preview_theme_id' || k === 'pb' || k.startsWith('preview_')) u.searchParams.set(k, v);
    return u.pathname + u.search;
  };
  const page = async n => {
    const r = await fetch(indexUrl(n), {credentials:'same-origin', cache:'no-store'});
    if (!r.ok) throw new Error(`Arabic index ${r.status}`);
    return r.json();
  };
  const catalog = () => catalogPromise || (catalogPromise = (async () => {
    const first = await page(1), all = [...(first.products || [])], total = Math.min(Number(first.pages || 1), 40);
    for (let n = 2; n <= total; n += 4) {
      const nums = [n,n+1,n+2,n+3].filter(x => x <= total);
      const batches = await Promise.all(nums.map(page));
      batches.forEach(x => all.push(...(x.products || [])));
    }
    const seen = new Set();
    return all.filter(p => { const k = p.url || p.product_handle || p.title; if (!k || seen.has(k)) return false; seen.add(k); return true; });
  })().catch(e => { catalogPromise = null; throw e; }));
  const findLocalizedMatches = (q, products) => {
    if (!simpleArabic(q) || norm(q).length < 2) return [];
    return (products || [])
      .filter(p => matches(q,p))
      .sort((a,b) => score(q,a)-score(q,b) || String(a.title||'').localeCompare(String(b.title||''),'ar'));
  };
  const search = async (q, limit = 24) => findLocalizedMatches(q, await catalog()).slice(0,limit);

  const styles = () => {
    if (document.getElementById('loubna-ar-v10-style')) return;
    const s = document.createElement('style'); s.id = 'loubna-ar-v10-style';
    s.textContent = `.loubna-ar-dd{position:absolute;top:calc(100% + 8px);inset-inline-end:0;width:max(100%,360px);max-width:calc(100vw - 24px);background:#fffdf8;border:1px solid rgba(23,62,51,.18);border-radius:12px;box-shadow:0 12px 32px rgba(23,62,51,.16);z-index:10020;overflow:hidden;text-align:start;color:#173e33}.loubna-ar-dd[hidden]{display:none!important}.loubna-ar-dd ul{list-style:none;margin:0;padding:6px}.loubna-ar-dd li{margin:0}.loubna-ar-dd a{display:grid;grid-template-columns:50px minmax(0,1fr);gap:10px;align-items:center;padding:8px;color:inherit;text-decoration:none;border-radius:8px}.loubna-ar-dd a:hover{background:rgba(23,62,51,.06)}.loubna-ar-dd img{width:50px;height:64px;object-fit:contain}.loubna-ar-dd strong,.loubna-ar-dd small{display:block;line-height:1.35}.loubna-ar-dd small{opacity:.75;margin-top:3px}.loubna-ar-dd__msg,.loubna-ar-dd__all{padding:12px!important;display:block!important}.loubna-ar-dd__all{border-top:1px solid rgba(23,62,51,.1);font-weight:700;text-align:center}.loubna-ar-card{display:flex;flex-direction:column;height:100%;text-decoration:none;color:inherit}.loubna-ar-card__img{width:100%;aspect-ratio:3/4;object-fit:contain;background:rgba(var(--color-foreground),.035)}.loubna-ar-card__body{padding-top:1rem}.loubna-ar-card__title{margin:0 0 .5rem;font-size:1.5rem;line-height:1.35}.loubna-ar-card__price{margin:0;font-size:1.4rem}`;
    document.head.appendChild(s);
  };
  const searchUrl = (form,q) => {
    const u = new URL(form.action || `${prefix()}/search`, location.origin); u.searchParams.set('q', q); u.searchParams.set('options[prefix]','last');
    const src = new URLSearchParams(location.search); for (const [k,v] of src) if (k === 'preview_theme_id' || k === 'pb' || k.startsWith('preview_')) u.searchParams.set(k,v);
    return u.pathname + u.search;
  };
  const autocomplete = form => {
    if (form.dataset.loubnaArV10) return;
    const input = form.querySelector('input[type="search"][name="q"]'); if (!input) return;
    form.dataset.loubnaArV10 = '1'; if (getComputedStyle(form).position === 'static') form.style.position = 'relative';
    const box = document.createElement('div'); box.className = 'loubna-ar-dd'; box.hidden = true; form.appendChild(box);
    let timer, seq = 0;
    const close = () => { box.hidden = true; box.innerHTML = ''; };
    const message = m => { box.innerHTML = ''; const d = document.createElement('div'); d.className='loubna-ar-dd__msg'; d.textContent=m; box.appendChild(d); box.hidden=false; };
    const render = (q, list) => {
      box.innerHTML = '';
      if (!list.length) return message('لا توجد نتائج مطابقة');
      const ul = document.createElement('ul');
      list.forEach(p => { const li=document.createElement('li'), a=document.createElement('a'); a.href=p.url || '#';
        if (p.image) { const im=document.createElement('img'); im.src=p.image; im.alt=p.title||''; im.loading='lazy'; a.appendChild(im); } else a.appendChild(document.createElement('span'));
        const tx=document.createElement('span'), st=document.createElement('strong'), sm=document.createElement('small'); st.textContent=p.title||''; sm.textContent=p.price||''; tx.append(st,sm); a.appendChild(tx); li.appendChild(a); ul.appendChild(li); });
      box.appendChild(ul); const all=document.createElement('a'); all.className='loubna-ar-dd__all'; all.href=searchUrl(form,q); all.textContent=`عرض كل النتائج لـ «${q}»`; box.appendChild(all); box.hidden=false;
    };
    const run = async () => { const q=input.value.trim(); if (!simpleArabic(q) || norm(q).length < 2) return close(); const id=++seq; message('جارٍ البحث...');
      try { const list=await search(q,6); if (id===seq && input.value.trim()===q) render(q,list); } catch(e) { close(); console.warn('[Loubna Arabic Search V10]',e); } };
    input.addEventListener('input', () => { clearTimeout(timer); timer=setTimeout(run,200); });
    input.addEventListener('focus', () => { if (simpleArabic(input.value) && norm(input.value).length >= 2) run(); });
    input.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    document.addEventListener('pointerdown', e => { if (!form.contains(e.target)) close(); });
  };

  const nativeHasProduct = () => !!document.querySelector('.template-search a[href*="/products/"], .template-search [data-product-id]');
  const renderPage = (q, list) => {
    const container=document.getElementById('ProductGridContainer'); if (!container || !list.length) return;
    const wrap=document.createElement('div'); wrap.className='template-search__results collection page-width'; wrap.id='product-grid';
    const ul=document.createElement('ul'); ul.className='grid product-grid grid--2-col-tablet-down grid--4-col-desktop'; ul.setAttribute('role','list');
    list.forEach(p => { const li=document.createElement('li'); li.className='grid__item'; const a=document.createElement('a'); a.className='loubna-ar-card'; a.href=p.url||'#';
      if (p.image) { const im=document.createElement('img'); im.className='loubna-ar-card__img'; im.src=p.image; im.alt=p.title||''; im.loading='lazy'; a.appendChild(im); }
      const b=document.createElement('div'); b.className='loubna-ar-card__body'; const h=document.createElement('h3'); h.className='loubna-ar-card__title'; h.textContent=p.title||''; const pr=document.createElement('p'); pr.className='loubna-ar-card__price'; pr.textContent=p.price||''; b.append(h,pr); a.appendChild(b); li.appendChild(a); ul.appendChild(li); });
    wrap.appendChild(ul); container.replaceChildren(wrap); document.querySelector('.template-search')?.classList.remove('template-search--empty');
    document.querySelectorAll('input[name="q"]').forEach(i => i.value=q);
    const header=document.querySelector('.template-search__header'); if (header) { header.querySelectorAll('p[role="status"]').forEach(x => x.hidden=true); const p=document.createElement('p'); p.setAttribute('role','status'); p.style.textAlign='center'; p.textContent=`نتائج البحث عن «${q}»: ${list.length}`; header.appendChild(p); }
  };
  const pageFallback = async () => {
    if (!document.querySelector('.template-search') || nativeHasProduct()) return;
    const params=new URLSearchParams(location.search), q=(params.get('q')||'').trim();
    if (!simpleArabic(q) || [...params.keys()].some(k => k.startsWith('filter.'))) return;
    try { const list=await search(q,24); if (!nativeHasProduct() && list.length) renderPage(q,list); } catch(e) { console.warn('[Loubna Arabic Search V10]',e); }
  };

  window.LoubnaArabicSearch = {
    version: 10,
    normalize: norm,
    cleanSurface: norm,
    canonicalArabic: norm,
    isSimpleArabicQuery: simpleArabic,
    findLocalizedMatches,
    getCatalogIndexUrl: indexUrl,
    getLocalePrefixFromSearchPath: prefix,
    search
  };
  const boot = () => { styles(); document.querySelectorAll('.loubna-header__search,.loubna-header__mobile-search').forEach(autocomplete); pageFallback(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
})();
